//Redux
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeModal } from "../../reducers/modalReducer";
//Components
import { Modal } from "@almafintech/react-components/Modal";
//Styles
import styles from "./RiskProfileModal.module.scss";
//Utils
import { riskProfileModalTexts } from "../../i18n/securities/riskPorfileModal";

const RiskProfileModal = ({ language }: { language: "es" | "en" }) => {
  const { container, item } = styles;

  const dispatch = useAppDispatch();

  const { modalName } = useAppSelector((state) => state.modal);

  const handleClose = () => {
    dispatch(closeModal());
  };

  return (
    <Modal
      isOpen={modalName === "risk-profile-securities"}
      onClose={handleClose}
      className={container}
      header={
        <header>
          <h1>{riskProfileModalTexts[language].header}</h1>
        </header>
      }
    >
      <section>
        <div className={item}>
          <p>{riskProfileModalTexts[language].conservativeProfileTitle}</p>
          <p>{riskProfileModalTexts[language].conservativeProfile}</p>
        </div>
        <div className={item}>
          <p>{riskProfileModalTexts[language].moderateProfileTitle}</p>
          <p>{riskProfileModalTexts[language].moderateProfile}</p>
        </div>
        <div className={item}>
          <p>{riskProfileModalTexts[language].aggressiveProfileTitle}</p>
          <p>{riskProfileModalTexts[language].aggressiveProfile}</p>
        </div>
        <div className={item}>
          <p>{riskProfileModalTexts[language].especulativeProfileTitle}</p>
          <p>{riskProfileModalTexts[language].especulativeProfile}</p>
        </div>
      </section>
    </Modal>
  );
};

export default RiskProfileModal;
